import React from 'react';

import { Box, Typography, Input } from '@mui/joy';

export interface FormFieldConfig {
  key: string;
  label: string;
  value: string | number;
  unit?: string;
  type?: 'text' | 'number';
  readOnly?: boolean;
  step?: number;
}

interface DynamicFormFieldsProps {
  fields: Record<string, FormFieldConfig>;
  fieldOrder: string[];
  onChange?: (key: string, value: string | number) => void;
}

const DynamicFormFields: React.FC<DynamicFormFieldsProps> = ({ fields, fieldOrder, onChange }) => {
  const handleFieldChange = (key: string, value: string) => {
    if (onChange) {
      const fieldConfig = fields[key];
      const parsedValue = fieldConfig?.type === 'number' ? parseFloat(value) || 0 : value;
      onChange(key, parsedValue);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {fieldOrder.map((fieldKey) => {
        const field = fields[fieldKey];
        if (!field) return null;

        return (
          <Box key={fieldKey}>
            <Typography level='body-sm' sx={{ color: 'neutral.300', mb: 0.5 }}>
              {field.label}
            </Typography>
            <Input
              value={field.value.toString()}
              type={field.type === 'number' ? 'number' : 'text'}
              readOnly={field.readOnly}
              onChange={(e) => handleFieldChange(fieldKey, e.target.value)}
              slotProps={{
                input: {
                  step: field.step
                }
              }}
              endDecorator={
                field.unit ? (
                  <Typography level='body-sm' sx={{ color: 'neutral.400' }}>
                    {field.unit}
                  </Typography>
                ) : undefined
              }
              sx={{
                backgroundColor: 'neutral.700',
                border: 'none',
                '& input': {
                  color: 'neutral.100',
                  cursor: field.readOnly ? 'default' : 'text'
                },
                opacity: field.readOnly ? 0.8 : 1
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default DynamicFormFields;
